import isVerifyTokenGuard from "@/guards/verifyTokenGuard";
import verifyTokenGuardWithoutPermission from "@/guards/verifyTokenGuardWithoutPermission";

export default {
    name: 'clinical-history',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: 'create/:patient_id',
            name: 'clinical-history-create',
            // beforeEnter: [isVerifyTokenGuard],
            beforeEnter: [verifyTokenGuardWithoutPermission],
            meta: {
                breadcrumbs: [     
                    {
                        route: {
                            name: 'digital-record-index',
                        },
                        params: ["patient_id"],
                        transKey: 'breadcrumbs.clinical-history',
                        isActive: false,
                    },              
                    {                           
                        transKey: 'breadcrumbs.short-clinical-history-create',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "clinical-history-create" */ '@/modules/digital-record/clinical-history/views/Create.vue')
        },
        {
            path: 'edit/:patient_id/:short_clinical_history_id',
            name: 'clinical-history-edit',
            // beforeEnter: [isVerifyTokenGuard],
            beforeEnter: [verifyTokenGuardWithoutPermission],
            meta: {
                breadcrumbs: [     
                    {
                        route: {
                            name: 'digital-record-index',
                        },
                        params: ["patient_id"],
                        transKey: 'breadcrumbs.clinical-history',
                        isActive: false,
                    },              
                    {                           
                        transKey: 'breadcrumbs.short-clinical-history-update',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "clinical-history-edit" */ '@/modules/digital-record/clinical-history/views/Edit.vue')
        },
        {
            path: 'detail/:patient_id/:short_clinical_history_id',
            name: 'clinical-history-detail',
            // beforeEnter: [isVerifyTokenGuard],
            beforeEnter: [verifyTokenGuardWithoutPermission],
            meta: {
                breadcrumbs: [     
                    {
                        route: {
                            name: 'digital-record-index',
                        },
                        params: ["patient_id"],
                        transKey: 'breadcrumbs.clinical-history',
                        isActive: false,
                    },              
                    {                           
                        transKey: 'breadcrumbs.short-clinical-history-detail',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "clinical-history-edit" */ '@/modules/digital-record/clinical-history/views/Edit.vue')
        }
    ]
}